import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { foundItems } from "../../../features/LostFound/dummy/fountItems";

// Initial state
const initialState = {
  loading: null,
  loaded: null,
  error: null,
  data: null,
  phoneNumber: null,
};

// Slice
const decryptPhoneNumberSlice = createSlice({
  name: "decryptPhoneNumber",
  initialState,
  reducers: {
    getPhoneNumber(state) {
      return { ...state, loading: true, error: false };
    },
    setPhoneNumber(state, action) {
      const { phoneNumber } = action.payload;
      return { ...state, phoneNumber };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  getPhoneNumber,
  setPhoneNumber,
  fetchDataSuccess,
  fetchDataFailure,
} = decryptPhoneNumberSlice.actions;

export default decryptPhoneNumberSlice.reducer;

//saga

function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });
    const response = yield call(apiService.post, apiUrl, data);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { code, data } = response.data;
      if (code === "0000") {
        yield put(setPhoneNumber({ phoneNumber: data }));
        // yield put(setItems({ list: [] }));
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* decryptPhoneNumberSaga() {
  yield takeLatest(getPhoneNumber.type, fetchDataSaga);
}
